// extracted by mini-css-extract-plugin
export default {"note":"Note_note__6KKz6","noteContainer":"Note_noteContainer__oZmlE","buttonTag":"Note_buttonTag__JWRFN"};